export interface AgentSummary {
    name: string;
    uuid: string;
    isRoot: boolean;
    canBeSubAgent: boolean;
    canHaveSubAgents: boolean;
    agentVersionId: number | null;
    versionNumber: number | null;
    subAgents: string[];
    candidateSubAgents: string[];
    hasDraft: boolean;
    type: string | null;
}

/**
 * "rag_agent" -> "Rag Agent". The backend has no display-name field for agents (`name` is the
 * folder name under `agents/`), so this is what the picker shows until one exists.
 */
export function agentDisplayName(name: string): string {
    return name
        .split("_")
        .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : word))
        .join(" ");
}
